<template>
  <v-col cols="12" sm="9" md="12" lg="12" xl="12" class="mt-6">
    <p class="font-weight-bold">{{ product.Code }}</p>
    <v-row no-gutters>
      <v-col cols="1">
        <v-layout v-if="productImages[product.Code] && product.Images[0]">
          <topImage
            :productImages="productImages[product.Code]"
            :productImage="product.Images[0]"
          />
        </v-layout>
      </v-col>
      <v-col cols="11">
        <v-row no-gutters align="center">
          <v-col cols="11" sm="10" md="10" lg="11" xl="11">
            <v-simple-table dense class="pa-md-2 pa-lg-2 pa-xl-2 bg-color-grey" >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">{{ $t("Color") }}</th>
                    <th
                      class="text-center"
                      v-for="(item, index) in getProcuctSizes"
                      :key="index"
                    >
                      <headerPrice
                        :item="item"
                        :index="index"
                        :product="product"
                        :currencyItem="currency"
                        :stockItems="stockItems"
                        :ref="'headerItem' + [index]"
                      />
                    </th>

                    <th class="text-left">
                      {{ $t("Total") }}
                    </th>
                    <th v-if="isCartItem" class="text-left">
                      {{ $t("Delete") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <orderListItem
                    v-for="(item, index) in product.Variants"
                    :key="index"
                    :orderListItem="item"
                    :productCode="product.Id"
                    :ref="'productvariant' + index"
                    :isCartItem="isCartItem"
                    :availableSizes="getProcuctSizes"
                    :customerId="customerIdParent"
                    @cartItems="prepareCartItemsForUpdate"
                    @changePrice="resetCart"
                    @updateTotalPrice="updateTotalPrice"
                  />
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-row no-gutters v-if="!isCartItem">
          <v-spacer></v-spacer>
          <v-col class="text-right mr-4 mb-4 mt-2">
            <!-- @click="addItemsToShoppingcart()" -->
            <v-btn depressed color="primary" small>
              <v-icon left> mdi-cart </v-icon>
              {{ $t("Add") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-snackbar
          v-model="snackbar"
          :color="snackbarColor"
          :timeout="timeout"
          app
        >
          {{ snackbarText }}

          <template v-slot:action="{ attrs }">
            <v-btn color="white" v-bind="attrs" @click="snackbar = false" icon>
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </template>
        </v-snackbar>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col>
        <v-divider class="mr-4"></v-divider>
      </v-col>
    </v-row>
  </v-col>
</template>
  
  <script>
import request from "@/request";
import orderListItem from "../fashion/OrderListItem.vue";
import topImage from "../fashion/TopImage.vue";
import headerPrice from "../fashion/HeaderPrice.vue";
export default {
  props: [
    "product",
    "productImages",
    "isCartItem",
    "stockItems",
    "currencyFromParent",
    "customerId",
  ],
  data() {
    return {
      apiUrl: this.$config.apiUrls.Dev,
      toBeUpdatedCart: [],
      show: [],
      currency: this.currencyFromParent,

      snackbar: false,
      snackbarText: null,
      timeout: 4000,
      snackbarColor: null,
      customerIdParent: this.customerId,
    };
  },
  components: {
    orderListItem,
    topImage,
    headerPrice
  },

  computed: {
    getCurrencyItem() {
      return this.currency;
    },
    getcurrency() {
      let currencySign;
      switch (this.currency) {
        case "EUR":
          currencySign = "€ ";
          break;
        case "GBP":
          currencySign = "£ ";
          break;
        case "USD":
          currencySign = "$ ";
          break;

        default:
          currencySign = "€ ";
          break;
      }
      return currencySign;
    },
    getProcuctSizes() {
      let standardSizes = [];

      if (this.stockItems && this.isCartItem) {
        this.stockItems.Stock.forEach((el) => {
          standardSizes.push({ Size: el.Size, NetPrices: el.NetPrices });
        });
      } else {
        this.product.Variants[0].Stock.forEach((el) => {
          standardSizes.push({ Size: el.Size, NetPrices: el.NetPrices });
        });
      }
      return standardSizes;
    },

    productCodes() {
      let codes = [];
      this.product.Variants.forEach((el) => {
        codes.push(el.Code);
      });
      return codes;
    },
    productColors() {
      let productColors = [];
      this.product.Variants.forEach((el) => {
        productColors.push(el.ColorId);
      });
      return productColors;
    },
  },
  methods: {
    changeCurrency(currency) {
      if (currency) {
        this.currency = currency;
        for (const [key] of Object.entries(this.$refs)) {
          this.$refs[key][0].changeCurrency(this.currency);
        }
      }
    },
    addItemsToShoppingcart() {
      if (this.toBeUpdatedCart.length > 0) {
        let urlFilter = this.customerIdParent
          ? "?customerId=" + this.customerIdParent
          : "";
        request.post(
          "/api/kdesign/basketadd" + urlFilter,
          [...this.toBeUpdatedCart],
          (res) => {
            if (res.success) {
              // show snackbar
              this.snackbar = true;
              this.snackbarText = this.$t(
                "Item successfully added to shopping cart."
              );
              this.snackbarColor = "success";
              //bascid count update
              this.product.Variants.forEach((element, index) => {
                this.$refs["productvariant" + index][0].resetCart();
              });
              this.$emit("updateCart", this.customerIdParent);
              //update prepare item
              this.toBeUpdatedCart = [];
              //set clear event to child component
            } else {
              this.snackbar = true;
              this.snackbarText = this.$t(
                "Oops something went wrong, please try again."
              );
              this.snackbarColor = "error";
            }
          }
        );
      } else {
        this.snackbar = true;
        this.snackbarText = this.$t("Add a size.");
        this.snackbarColor = "warning";
      }
    },
    prepareCartItemsForUpdate(items) {
      if (items.length > 0) {
        items.forEach((element) => {
          this.toBeUpdatedCart.push(element);
        });
      }
    },
    clearItemOutPrepItem(item) {
      this.toBeUpdatedCart = this.toBeUpdatedCart.filter(
        (el) => el.VariantCode !== item.Code
      );
    },
    resetCart() {
      this.$emit("changePrice");
    },
    updateTotalPrice() {
      this.$emit("updateTotalPrice");
    },
    updateCutomerId(param) {
      this.customerIdParent = param;
      this.product.Variants.forEach((element, index) => {
        this.$refs["productvariant" + index][0].updateCutomerId(param);
      });
    },
  },
};
</script>
  
  <style>
</style>